module.exports = __webpack_public_path__ + "img/thumbnail-3.ad12bd9c.jpg";